import React from 'react';

import { CssBaseline } from '@material-ui/core';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Router } from './router/router';
import ProgramApisProvider from './providers/ProgramApisProvider';
import RafflesStoreProvider from './providers/RafflesStoreProvider';
import ViewportProvider from './providers/ViewportProvider';
import ThemeProvider from './providers/ThemeProvider';
import Wallet from './components/Wallet';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
const App = () => {
  console.log(
   ` 
  %cBuilt By:
  
%c _____   _       _____   _   _        ___  ___   _____   _____   __   _  
|  _  \\ | |     /  _  \\ | | / /      /   |/   | /  _  \\ /  _  \\ |  \\ | | 
| |_| | | |     | | | | | |/ /      / /|   /| | | | | | | | | | |   \\| | 
|  _  { | |     | | | | | |\\ \\     / / |__/ | | | | | | | | | | | |\\   | 
| |_| | | |___  | |_| | | | \\ \\   / /       | | | |_| | | |_| | | | \\  | 
|_____/ |_____| \\_____/ |_|  \\_\\ /_/        |_| \\_____/ \\_____/ |_|  \\_|.com`

  ,
    "color: red;  font-size: 30px",
    "color: orange;  font-size: 30px"
  );
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ViewportProvider>
        <CssBaseline />
        <ThemeProvider>
          <BrowserRouter>
            <Wallet>
              <ProgramApisProvider>
                <RafflesStoreProvider>
                  <Router />
                  <Toaster
                    position="bottom-left"
                    reverseOrder={false}
                    toastOptions={{
                      duration: 5000,
                    }}
                  />
                  <ScrollToTop />
                </RafflesStoreProvider>
              </ProgramApisProvider>
            </Wallet>
          </BrowserRouter>
        </ThemeProvider>
      </ViewportProvider>
    </LocalizationProvider>
  );
};

export default App;
